module.exports = __webpack_public_path__ + "img/dataLoading.015c5cd1.gif";